<template>
  <v-col :cols="btnParc ? 12 : 3" :class="btnParc ? 'pt-0' : '' ">
    <template v-if="btnParc">
      <input-text v-show="false" label="Parcelas" v-model="model" required />
      <v-label>Parcelas:</v-label>
      <v-item-group required v-model="model" @change="change">
        <v-row>
          <v-col :cols="parseInt(12/parcelas.length)" v-for="(item, i) in parcelas" :key="i">
            <v-item v-slot="{ active, toggle }" :value="item.value">
              <v-btn block large tile @click="toggle" :color="active? 'grey darken-3' : ''" class="px-4 text-lowercase" :dark="active">
                {{item.text}}
              </v-btn>
            </v-item>
          </v-col>
        </v-row>
      </v-item-group>
    </template>
    <input-select v-else :options="parcelas" required name="Parcelas" label="Parcelar em até:" v-model="model" @change="change"></input-select>
  </v-col>
</template>

<script>
export default {
  props: {
    value: null,
    dados: null
  },
  data () {
    return {
      parcelas: []
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    btnParc: function () {
      return this.parcelas.length < 6
    }
  },
  methods: {
    change (value) {
      this.$emit('change', value)
    },
    setParcela (loading) {
      const ultima = this.parcelas && this.parcelas.length > 0 ? this.parcelas[this.parcelas.length - 1].value : null
      if (!loading && this.model.Parcelas > ultima) { this.$set(this.model, 'Parcelas', ultima) }
    }
  },
  beforeMount () {
    const th = this
    th.$api.Multiplo.Post('ListProdutoRedeParcela', {}).then(function (response) {
      th.parcelas = []
      let prazos = []
      if (th.$param.TabelaTaxas[0].id) {
        prazos = th.$param.TabelaTaxas.find(p => p.id === (th.dados.PropostaDadosVeiculo.TipoSegmento || th.dados.PropostaDadosVeiculo?.TipoPlaca || 1)).value.map(p => p.prazo)
      } else {
        prazos = th.$param.TabelaTaxas.map(p => p.prazo)
      }
      const prazosSemDuplicados = prazos.filter((valor, indice, arr) => {
        return arr.indexOf(valor) === indice;
      }).sort((a, b) => a - b);
      for (var i = 0; i < prazosSemDuplicados.length; i++) {
        var obj = { value: prazosSemDuplicados[i], text: prazosSemDuplicados[i] + 'x' }
        th.parcelas.push(obj)
      }
      th.setParcela(true)
      th.$emit('load', th.parcelas.length < 6)
    })
  }
}
</script>
